import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import SyncIcon from "@mui/icons-material/Sync";
import { useTranslation } from "react-i18next";
import SemButton from "../../../common/components/Button";
import { isDateDiffDaysOld } from "../../../helperJs/helper";

const RefreshDataButton = ({ date, handleRefresh, disable }) => {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const handleClick = (e) => {
    if (typeof handleRefresh === "function") {
      handleRefresh(e, "post");
    } else {
      console.log("handleRefresh is not a function");
    }
  };

  useEffect(() => {
    const dateToCheck = dayjs(date);
    setOpen(isDateDiffDaysOld(dateToCheck, 15)); // previous 7days
  }, [date]);

  if (!open) return null;
  return (
    <SemButton
      name={t("common_buttons.refresh")}
      title={t("common_buttons.refresh")}
      disabled={disable}
      onClick={handleClick}
      icon={<SyncIcon fontSize="small" />}
    />
  );
};

export default React.memo(RefreshDataButton);
